import { Container, Store } from 'AppReact';
import { SolidButton } from './../../../../common/molecules';
import { ModalBodyAtom } from './atoms';
import { InputError, Input, } from 'molecules';
import { GenericWrapper } from 'wrappers';
import { FieldWrapper } from './wrapper';
import { trimText } from 'utils';
import { calculateTotalFee } from '../../../../utils';


const ModalBody = Container({
  name: 'ModalBody',
  props: { property: Store, cardDetails: Store, occupants: Store, termsModal: Store, leaseholderName: Store, termsAccepted: Store },
  elements: [
    {
      wrapper: GenericWrapper,
      name: 'Container',
      elements: [
        {
          component: ModalBodyAtom,
          name: 'Terms',
          bindings: ({ }) => ({}),
          displayValue: () => ''
        },
        {
          wrapper: GenericWrapper,
          name: 'AgreeSection',
          elements: [
            {
              wrapper: FieldWrapper,
              name: 'Field',
              elements: [
                {
                  component: Input,
                  name: 'Name',
                  bindings: ({ occupants, leaseholderName }) => ({ label: '', placeholder: `Name on Lease (${occupants[0].name}):`, value: leaseholderName, occupants })
                },
                {
                  component: SolidButton,
                  name: 'Button',
                  bindings: ({ occupants, leaseholderName, property, cardDetails }) => {
                    const paidFee = calculateTotalFee(property, occupants, true);
                    return { 
                      occupants, 
                      property, 
                      isAdminFeePaid: cardDetails.IsAdminFeePaid, 
                      title: paidFee > 0 ? "Agree" : "Agree & Submit", 
                      big: true, 
                      disabled: trimText(leaseholderName.toLowerCase()) !== (occupants.length && trimText(occupants[0].name.toLowerCase())) 
                    }},
                },
              ]
            },
            {
              component: InputError,
              name: 'NameError',
              bindings: ({ }) => ({ error: 'Enter the name of lease holder as per apllication' }),
              renderIf: ({ leaseholderName, occupants }) =>
                trimText(leaseholderName.toLowerCase()) !== (occupants.length && trimText(occupants[0].name.toLowerCase()))
            },
          ]
        },
      ]
    },


  ]
})

export default ModalBody;
